import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

// ** bulk create subscription
export const bulkCreateSubscriptions = createAsyncThunk(
  "PartnerSubscription/bulk-create-subscriptions",
  async (subscriptionData: any, { rejectWithValue }) => {
    try {
      const result = await axios.post(
        `partner-bulk-create-subscriptions`,
        subscriptionData,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// ** update all subscriptions
export const updateAllSubscriptions = createAsyncThunk(
  "PartnerSubscription/update-all-subscriptions",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.put(
        `partner-update-all-subscriptions`,
        data,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// ** bulk update subscription
export const updateGroupedSubscriptions = createAsyncThunk(
  "PartnerSubscription/bulk-update-subscriptions",
  async (reservationData: any, { rejectWithValue }) => {
    try {
      const result = await axios.put(
        `partner-bulk-update-subscriptions`,
        reservationData,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// ** bulk update subscription
export const updateSingleSubscription = createAsyncThunk(
  "PartnerSubscription/update-single-subscriptions",
  async (
    {
      subscriptionId,
      subscriptionData,
    }: { subscriptionId: any; subscriptionData: any },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.put(
        `partner-update-single-subscriptions/${subscriptionId}`,
        subscriptionData,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// ** get partner subscription list
export const getSubscriptionList = createAsyncThunk(
  "PartnerSubscription/get-subscription-list",
  async (
    {
      page,
      currentPage,
      limit,
    }: { page: number; currentPage: number; limit: number },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(`partner-get-subscription-list`, {
        withCredentials: true,
        params: {
          page,
          currentPage,
          limit,
        },
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// ** Bulk cancel subscription
export const bulkCancelSubscriptions = createAsyncThunk(
  "PartnerSubscription/bulk-cancel-subscriptions",
  async (subscriptionData: any, { rejectWithValue }) => {
    try {
      const result = await axios.put(
        `partner-bulk-cancel-subscriptions`,
        subscriptionData,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);
// ** cancel partner subscription
export const cancelSingleSubscription = createAsyncThunk(
  "PartnerSubscription/cancel-reservation",
  async (
    { subscriptionID, data }: { subscriptionID: String | undefined; data: any },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.put(
        `partner-cancel-subscription/${subscriptionID}`,
        data,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// ** get subscription details by sub number
export const getSubscriptionDetails = createAsyncThunk(
  "PartnerSubscription/get-subscription-details",
  async (subscriptionNumber: any, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `partner-get-subscription-details/${subscriptionNumber}`,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// ** get archived subscription details by sub number
export const getArchivedSubscriptionDetails = createAsyncThunk(
  "PartnerSubscription/get-archived-subscription-details",
  async (subscriptionNumber: any, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `partner-get-archived-subscription-details/${subscriptionNumber}`,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// ** get partner archived subscription list
export const getArchivedSubscriptionList = createAsyncThunk(
  "PartnerSubscription/get-archived-subscription-list",
  async (
    {
      page,
      currentPage,
      limit,
    }: { page: number; currentPage: number; limit: number },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(
        `partner-get-archived-subscription-list`,
        {
          withCredentials: true,
          params: {
            page,
            currentPage,
            limit,
          },
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// ** get list of reservation to be exported on csv file
export const exportSubscriptionsList = createAsyncThunk(
  "PartnerSubscription/export-subscriptions-list",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.post(
        `partner-export-subscriptions-list`,
        data,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// ** resend subscription qrcode
export const resendPartnerSubscription = createAsyncThunk(
  "PartnerSubscription/resend-subscription-qrcode",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.post(`partner-resend-subscription`, data, {
        withCredentials: true,
      });
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// ** delete partner subscription
export const deleteSingleSubscription = createAsyncThunk(
  "PartnerSubscription/delete-subscription",
  async (
    { subscriptionID, data }: { subscriptionID: String | undefined; data: any },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.put(
        `partner-delete-subscription/${subscriptionID}`,
        data,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// ** get all subscriptions numbers
export const getAllSubscriptionsNumbers = createAsyncThunk(
  "PartnerSubscription/get-all-subscriptions-numbers",
  async (_, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `partner-get-all-subscriptions-numbers`,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// ** get ungrouped subscription
export const getUngroupedSubscriptions = createAsyncThunk(
  "PartnerSubscription/get-ungrouped-subscription-list",
  async (
    {
      page,
      currentPage,
      limit,
    }: { page: number; currentPage: number; limit: number },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(
        `partner-get-ungrouped-subscriptions`,
        {
          withCredentials: true,
          params: {
            page,
            currentPage,
            limit,
          },
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// ** get ungrouped archived subscription
export const getArchivedUngroupedSubscriptions = createAsyncThunk(
  "PartnerSubscription/get-ungrouped-archived-subscription-list",
  async (
    {
      page,
      currentPage,
      limit,
    }: { page: number; currentPage: number; limit: number },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(
        `partner-get-ungrouped-archived-subscriptions`,
        {
          withCredentials: true,
          params: {
            page,
            currentPage,
            limit,
          },
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const bulkDeleteSubscriptions = createAsyncThunk(
  "PartnerSubscription/bulk-delete-subscription",
  async (subscriptionData: any, { rejectWithValue }) => {
    try {
      const result = await axios.put(
        `partner-bulk-delete-subscriptions`,
        subscriptionData,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// get single subscription details
export const getSingleSubscriptionDetails = createAsyncThunk(
  "PartnerSubscription/get-single-subscription-details",
  async (subscriptionId: any, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `partner-get-single-subscription-details/${subscriptionId}`,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// get single archived subscription details
export const getSingleArchivedSubscriptionDetails = createAsyncThunk(
  "PartnerSubscription/get-single-archived-subscription-details",
  async (subscriptionId: any, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `partner-get-single-archived-subscription-details/${subscriptionId}`,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getUpdatedSubscriptionsDetails = createAsyncThunk(
  "PartnerSubscription/get-updated-subscriptions-details",
  async (subscriptionNumber: any, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `partner-get-updated-subscriptions-details/${subscriptionNumber}`,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// get All partner ungrouped subscriptions
export const filterGroupedSubscriptions = createAsyncThunk(
  "PartnerSubscription/filter-grouped-subscriptions-list",
  async (
    {
      query,
      carType,
      status,
      startDate,
      endDate,
      actionType,
    }: {
      query: string | null;
      carType: string;
      status: string;
      startDate: string | Date | null;
      endDate: string | Date | null;
      actionType: "FILTER" | "RESET" | "FETCH" | null;
    },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(
        `partner-filter-grouped-subscriptions`,
        {
          withCredentials: true,
          params: {
            query,
            carType,
            status,
            startDate,
            endDate,
            actionType,
          },
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// get All partner ungrouped subscriptions
export const filterUngroupedSubscriptions = createAsyncThunk(
  "PartnerSubscription/filter-ungrouped-subscriptions-list",
  async (
    {
      query,
      carType,
      status,
      startDate,
      endDate,
      actionType,
    }: {
      query: string | null;
      carType: string;
      status: string;
      startDate: string | Date | null;
      endDate: string | Date | null;
      actionType: "FILTER" | "RESET" | "FETCH" | null;
    },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(
        `partner-filter-ungrouped-subscriptions`,
        {
          withCredentials: true,
          params: {
            query,
            carType,
            status,
            startDate,
            endDate,
            actionType,
          },
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// get All partner ungrouped subscriptions
export const filterArchivedGroupedSubscriptions = createAsyncThunk(
  "PartnerSubscription/filter-archived-grouped-subscriptions-list",
  async (
    {
      query,
      carType,
      status,
      startDate,
      endDate,
      actionType,
    }: {
      query: string | null;
      carType: string;
      status: string;
      startDate: string | Date | null;
      endDate: string | Date | null;
      actionType: "FILTER" | "RESET" | "FETCH" | null;
    },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(
        `partner-filter-archived-grouped-subscriptions`,
        {
          withCredentials: true,
          params: {
            query,
            carType,
            status,
            startDate,
            endDate,
            actionType,
          },
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// get All partner ungrouped subscriptions
export const filterArchivedUngroupedSubscriptions = createAsyncThunk(
  "PartnerSubscription/filter-archived-ungrouped-subscriptions-list",
  async (
    {
      query,
      carType,
      status,
      startDate,
      endDate,
      actionType,
    }: {
      query: string | null;
      carType: string;
      status: string;
      startDate: string | Date | null;
      endDate: string | Date | null;
      actionType: "FILTER" | "RESET" | "FETCH" | null;
    },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.get(
        `partner-filter-archived-ungrouped-subscriptions`,
        {
          withCredentials: true,
          params: {
            query,
            carType,
            status,
            startDate,
            endDate,
            actionType,
          },
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// * unarchive grouped subscription
export const unarchiveGroupedSubscriptions = createAsyncThunk(
  "PartnerSubscription/unarchive-grouped-subscriptions",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.put(
        `partner-unarchive-grouped-subscriptions`,
        data,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// * unarchive single subscription
export const unarchiveSingleSubscription = createAsyncThunk(
  "PartnerSubscription/unarchive-subscription",
  async (
    { subscriptionID, data }: { subscriptionID: String | undefined; data: any },
    { rejectWithValue },
  ) => {
    try {
      const result = await axios.put(
        `partner-unarchive-single-subscription/${subscriptionID}`,
        data,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

// * export archived subscriptions
export const exportArchivedSubscriptionsList = createAsyncThunk(
  "PartnerSubscription/export-archived-subscriptions-list",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.post(
        `partner-export-archived-subscriptions-list`,
        data,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const deleteMultipleSubscriptionEvents = createAsyncThunk(
  "PartnerSubscription/delete-multiple-subscription-events",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.put(
        `partner-delete-multiple-subscription-events`,
        data,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

export const deleteMultipleSubscriptions = createAsyncThunk(
  "PartnerSubscription/delete-multiple-subscriptions",
  async (data: any, { rejectWithValue }) => {
    try {
      const result = await axios.put(
        `partner-delete-multiple-subscriptions`,
        data,
        {
          withCredentials: true,
        },
      );
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result.data;
    } catch (error: any) {
      toast.error(error.response.data.Description, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return rejectWithValue(error.response.data);
    }
  },
);

export const exportGroupedSubscriptions = createAsyncThunk(
  "PartnerSubscription/export-grouped-subscriptions",
  async (subscriptionNumber: string, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `partner-export-grouped-subscriptions/${subscriptionNumber}`,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const exportArchivedGroupedSubscriptions = createAsyncThunk(
  "PartnerSubscription/export-archived-grouped-subscriptions",
  async (subscriptionNumber: string, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `partner-export-archived-grouped-subscriptions/${subscriptionNumber}`,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

const PartnerSubscription = createSlice({
  name: "PartnerSubscriptions",
  initialState: {
    subscription: {},
    groupedSubscriptions: [],
    ungroupedSubscriptions: [],
    loading: false,
    success: false,
    description: null,
    availablePlaces: null,
    exportedSubscriptions: [],
    subscriptionsNumbers: ["All"],
    pagination: null,
  },
  reducers: {
    clearErrors: (state) => {
      state.description = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // * bulk add subscription
      .addCase(bulkCreateSubscriptions.pending, (state) => {
        state.success = false;
        state.loading = true;
        state.description = null;
      })
      .addCase(bulkCreateSubscriptions.fulfilled, (state, action) => {
        state.success = action.payload.Success;
        state.loading = false;
        state.groupedSubscriptions = action.payload.Subscriptions;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(bulkCreateSubscriptions.rejected, (state: any, action: any) => {
        state.loading = false;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })

      // * bulk update subscription
      .addCase(updateGroupedSubscriptions.pending, (state) => {
        state.success = false;
        state.loading = true;
        state.description = null;
      })
      .addCase(updateGroupedSubscriptions.fulfilled, (state, action) => {
        state.success = action.payload.Success;
        state.loading = false;
        state.groupedSubscriptions = action.payload.Subscriptions;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        updateGroupedSubscriptions.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * get all partner subscription
      .addCase(getSubscriptionList.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(getSubscriptionList.fulfilled, (state, action) => {
        state.loading = false;
        state.groupedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(getSubscriptionList.rejected, (state: any, action: any) => {
        state.loading = false;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      // * gc cancel subscription
      .addCase(cancelSingleSubscription.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(cancelSingleSubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.ungroupedSubscriptions = action.payload.Subscriptions;
        state.subscription = action.payload.Pagination;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(cancelSingleSubscription.rejected, (state: any, action: any) => {
        state.loading = false;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      // * bulk cancel subscriptions
      .addCase(bulkCancelSubscriptions.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(bulkCancelSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.groupedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
        state.subscription = action.payload.Subscription;
      })
      .addCase(bulkCancelSubscriptions.rejected, (state: any, action: any) => {
        state.loading = false;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      // * get subscription details
      .addCase(getSubscriptionDetails.pending, (state) => {
        state.subscription = {};
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(getSubscriptionDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.subscription = action.payload.Subscription;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      .addCase(getSubscriptionDetails.rejected, (state: any, action: any) => {
        state.loading = false;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      // * resend subscription qrcode
      .addCase(resendPartnerSubscription.pending, (state) => {
        state.loading = true;

        state.success = false;
        state.description = null;
      })
      .addCase(resendPartnerSubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      .addCase(
        resendPartnerSubscription.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * get all partner archived subscription
      .addCase(getArchivedSubscriptionList.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(getArchivedSubscriptionList.fulfilled, (state, action) => {
        state.loading = false;
        state.groupedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        getArchivedSubscriptionList.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * get partner subscriptions list to be exported
      .addCase(exportSubscriptionsList.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(exportSubscriptionsList.fulfilled, (state, action) => {
        state.loading = false;
        state.exportedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      .addCase(exportSubscriptionsList.rejected, (state: any, action: any) => {
        state.loading = false;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      // * get archived subscription details
      .addCase(getArchivedSubscriptionDetails.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(getArchivedSubscriptionDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.subscription = action.payload.Subscription;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      .addCase(
        getArchivedSubscriptionDetails.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * update single subscription
      .addCase(updateSingleSubscription.pending, (state) => {
        state.success = false;
        state.loading = true;
        state.description = null;
      })
      .addCase(updateSingleSubscription.fulfilled, (state, action) => {
        state.success = action.payload.Success;
        state.loading = false;
        state.groupedSubscriptions = action.payload.Subscriptions;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(updateSingleSubscription.rejected, (state: any, action: any) => {
        state.loading = false;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      // * gc delete subscription
      .addCase(deleteSingleSubscription.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(deleteSingleSubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.ungroupedSubscriptions = action.payload.Subscriptions;
        state.subscription = action.payload.Subscription;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(deleteSingleSubscription.rejected, (state: any, action: any) => {
        state.loading = false;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      // * get all subscriptions numbers
      .addCase(getAllSubscriptionsNumbers.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(getAllSubscriptionsNumbers.fulfilled, (state, action) => {
        state.loading = false;
        state.subscriptionsNumbers = action.payload.Data;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      .addCase(
        getAllSubscriptionsNumbers.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * update all subscriptions
      .addCase(updateAllSubscriptions.pending, (state) => {
        state.success = false;
        state.loading = true;
        state.description = null;
      })
      .addCase(updateAllSubscriptions.fulfilled, (state, action) => {
        state.success = action.payload.Success;
        state.loading = false;
        state.groupedSubscriptions = action.payload.Subscriptions;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(updateAllSubscriptions.rejected, (state: any, action: any) => {
        state.loading = false;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      // * get ungrouped partner subscription
      .addCase(getUngroupedSubscriptions.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(getUngroupedSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.ungroupedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        getUngroupedSubscriptions.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * get ungrouped archived subscriptions */
      .addCase(getArchivedUngroupedSubscriptions.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(getArchivedUngroupedSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.ungroupedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        getArchivedUngroupedSubscriptions.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * bulk delete subscriptions
      .addCase(bulkDeleteSubscriptions.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(bulkDeleteSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.groupedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(bulkDeleteSubscriptions.rejected, (state: any, action: any) => {
        state.loading = false;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      // * get single subscription details
      .addCase(getSingleSubscriptionDetails.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(getSingleSubscriptionDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.subscription = action.payload.Subscription;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      .addCase(
        getSingleSubscriptionDetails.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * get single archived subscription details
      .addCase(getSingleArchivedSubscriptionDetails.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(
        getSingleArchivedSubscriptionDetails.fulfilled,
        (state, action) => {
          state.loading = false;
          state.subscription = action.payload.Subscription;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      .addCase(
        getSingleArchivedSubscriptionDetails.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * get updated subscription details
      .addCase(getUpdatedSubscriptionsDetails.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(getUpdatedSubscriptionsDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.subscription = action.payload.Subscription;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      .addCase(
        getUpdatedSubscriptionsDetails.rejected,
        (state: any, action: any) => {
          state.loading = false;

          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * filter grouped subscriptions
      .addCase(filterGroupedSubscriptions.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(filterGroupedSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.groupedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.pagination;
      })
      .addCase(
        filterGroupedSubscriptions.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * filter ungrouped subscriptions
      .addCase(filterUngroupedSubscriptions.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(filterUngroupedSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.ungroupedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.pagination;
      })
      .addCase(
        filterUngroupedSubscriptions.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )

      // * filter archived grouped subscriptions
      .addCase(filterArchivedGroupedSubscriptions.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(
        filterArchivedGroupedSubscriptions.fulfilled,
        (state, action) => {
          state.loading = false;
          state.groupedSubscriptions = action.payload.Subscriptions;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
          state.pagination = action.payload.pagination;
        },
      )
      .addCase(
        filterArchivedGroupedSubscriptions.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )

      // * filter archived ungrouped subscriptions
      .addCase(filterArchivedUngroupedSubscriptions.pending, (state) => {
        state.loading = true;
        state.success = false;

        state.description = null;
      })
      .addCase(
        filterArchivedUngroupedSubscriptions.fulfilled,
        (state, action) => {
          state.loading = false;
          state.ungroupedSubscriptions = action.payload.Subscriptions;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
          state.pagination = action.payload.pagination;
        },
      )
      .addCase(
        filterArchivedUngroupedSubscriptions.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * unarchive grouped subscription
      .addCase(unarchiveGroupedSubscriptions.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(unarchiveGroupedSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.groupedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        unarchiveGroupedSubscriptions.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )

      // * unarchive single subscription
      .addCase(unarchiveSingleSubscription.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(unarchiveSingleSubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.ungroupedSubscriptions = action.payload.Subscriptions;
        state.subscription = action.payload.Subscription;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        unarchiveSingleSubscription.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )

      // * export archived subscriptions
      .addCase(exportArchivedSubscriptionsList.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(exportArchivedSubscriptionsList.fulfilled, (state, action) => {
        state.loading = false;
        state.exportedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      .addCase(
        exportArchivedSubscriptionsList.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )

      // *  delete multi subscription events
      .addCase(deleteMultipleSubscriptionEvents.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(deleteMultipleSubscriptionEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.groupedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        deleteMultipleSubscriptionEvents.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )

      // * gc delete multi subscriptions
      .addCase(deleteMultipleSubscriptions.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(deleteMultipleSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.ungroupedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
        state.pagination = action.payload.Pagination;
      })
      .addCase(
        deleteMultipleSubscriptions.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      // * export selected grouped subscriptions
      .addCase(exportGroupedSubscriptions.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(exportGroupedSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.exportedSubscriptions = action.payload.Subscriptions;
        state.success = action.payload.Success;
        state.description = action.payload.Description;
      })
      .addCase(
        exportGroupedSubscriptions.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = false;
          state.description = action.payload.Description;
        },
      )

      // * export selected archived grouped subscriptions
      .addCase(exportArchivedGroupedSubscriptions.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.description = null;
      })
      .addCase(
        exportArchivedGroupedSubscriptions.fulfilled,
        (state, action) => {
          state.loading = false;
          state.exportedSubscriptions = action.payload.Subscriptions;
          state.success = action.payload.Success;
          state.description = action.payload.Description;
        },
      )
      .addCase(
        exportArchivedGroupedSubscriptions.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.success = false;
          state.description = action.payload.Description;
        },
      );
  },
});

export default PartnerSubscription.reducer;
